@if (abierto && elementosHijos?.length) {
  <div class="absolute z-50 w-full border-b border-gray-200 bg-white shadow-xl rounded-b-2xl animate-fadeIn">
    <div class="max-w-7xl mx-1 pb-9 pt-5 px-6">
      <div class="grid grid-cols-3 gap-8">
        <div>
          <h3 class="text-xs font-semibold text-purple-600 uppercase tracking-wider mb-4 pl-2">
            {{ descripcionOpcionMenu ? descripcionOpcionMenu : '' | translate }}
          </h3>
          @for (elementoHijo of elementosHijos; track elementoHijo) {
            <div class="py-1">
              <app-elemento-hijo-menu [elementoHijo]="elementoHijo" (childMenuClick)="cerrarPanel()">
              </app-elemento-hijo-menu>
            </div>
          }
        </div>
        @if (widget == 'gestion-usuarios-resumen') {
          <app-gestion-usuarios-resumen class="col-span-2 bg-linear-to-br from-gray-50 to-white p-6 rounded-2xl shadow-inner border border-gray-100">
          </app-gestion-usuarios-resumen>
        } @else if (widget == 'gestion-rag-resumen') {
          <app-gestion-rag-resumen class="col-span-2 bg-linear-to-br from-gray-50 to-white p-6 rounded-2xl shadow-inner border border-gray-100">
          </app-gestion-rag-resumen>
        } @else if (widget == 'gestion-integraciones-resumen') {
          <app-gestion-integraciones-resumen class="col-span-2 bg-linear-to-br from-gray-50 to-white p-6 rounded-2xl shadow-inner border border-gray-100">
          </app-gestion-integraciones-resumen>
        }
      </div>
    </div>
  </div>
}
